import React from "react";
import { NavLink } from "react-router-dom";
import {GlobalStyles} from "../../constants/styles";

export function UpgradeNoticeLink({ to = "/subscription/plans", style, children }) {
    return (
        <NavLink to={to} style={style}>
            {children}
        </NavLink>
    );
}

export default function UpgradeNotice({
                                          planLabel = "PRO",
                                          title = "Feature Unavailable",
                                          subtitle = "This feature is available on a premium plan.",
                                          ctaLabel = "Upgrade",
                                          to = "/subscription/plans",
                                          children,
                                          wrapClassName = "d-flex justify-content-center",
                                          maxWidth = 640,
                                          ui: customUi = {},
                                      }) {
    const ui = {
        noticeWrap: {
            width: "100%",
            maxWidth,
            background: "#fff",
            borderRadius: 14,
            border: "1px solid rgba(20,21,26,0.08)",
            boxShadow: "0 8px 24px rgba(20,21,26,0.08)",
            overflow: "hidden",
            ...customUi.noticeWrap,
        },
        noticeHeader: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 12,
            padding: "14px 16px",
            background:
                "linear-gradient(135deg, rgba(255,193,7,0.16), rgba(0,0,0,0))",
            borderBottom: "1px solid rgba(20,21,26,0.06)",
            ...customUi.noticeHeader,
        },
        noticeTitleWrap: {
            display: "flex",
            alignItems: "center",
            gap: 12,
            minWidth: 0,
            ...customUi.noticeTitleWrap,
        },
        badge: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            height: 24,
            padding: "0 10px",
            borderRadius: 999,
            fontSize: 12,
            fontWeight: 800,
            letterSpacing: 0.6,
            background: GlobalStyles.colors.warning,
            color: "#fff",
            flexShrink: 0,
            ...customUi.badge,
        },
        noticeTitle: {
            margin: 0,
            fontSize: 16,
            fontWeight: 800,
            color: "rgba(20,21,26,0.92)",
            lineHeight: 1.2,
            ...customUi.noticeTitle,
        },
        noticeSub: {
            margin: "2px 0 0 0",
            fontSize: 13,
            color: "rgba(20,21,26,0.70)",
            lineHeight: 1.25,
            ...customUi.noticeSub,
        },
        noticeBody: {
            padding: "12px 16px 14px 16px",
            ...customUi.noticeBody,
        },
        noticeP: {
            margin: 0,
            fontSize: 14,
            color: "rgba(20,21,26,0.82)",
            lineHeight: 1.5,
            ...customUi.noticeP,
        },
        noticeLink: {
            fontWeight: 800,
            color: "rgba(20,21,26,0.92)",
            textDecoration: "underline",
            ...customUi.noticeLink,
        },
    };

    return (
        <div className={wrapClassName}>
            <div style={ui.noticeWrap}>
                <div style={ui.noticeHeader}>
                    <div style={ui.noticeTitleWrap}>
                        <span style={ui.badge}>{planLabel}</span>

                        <div style={{ minWidth: 0 }}>
                            <h5 style={ui.noticeTitle}>{title}</h5>
                            <p style={ui.noticeSub}>{subtitle}</p>
                        </div>
                    </div>

                    <NavLink
                        to={to}
                        style={{
                            ...ui.badge,
                            background: "rgba(0,0,0,0.03)",
                            color: "rgba(20,21,26,0.70)",
                            textDecoration: "none",
                        }}
                    >
                        {ctaLabel}
                    </NavLink>
                </div>

                <div style={ui.noticeBody}>
                    <p style={ui.noticeP}>
                        {children ? (
                            children
                        ) : (
                            <>
                                To access this feature, please{" "}
                                <UpgradeNoticeLink to={to} style={ui.noticeLink}>
                                    upgrade your subscription
                                </UpgradeNoticeLink>
                                .
                            </>
                        )}
                    </p>
                </div>
            </div>
        </div>
    );
}
